import { useTranslation } from "react-i18next";

import { LoadingGroup, LoadingSkeleton } from "capitalrx-components-2.0/lib/general";
import { Grid, Stack } from "capitalrx-components-2.0/lib/layout";
import { Heading } from "capitalrx-components-2.0/lib/typography";

import { Pager } from "@/App/components";

import { DirectMemberReimbursementNoResults } from "./DirectMemberReimbursementNoResults";
import { DirectMemberReimbursementProviderDetailsCard, ProviderDetails } from "./DirectMemberReimbursementPharmacyDetailsCard";

interface PharmacySearchResults {
  readonly largeFieldsColumns: number;
  readonly pharmacies: ProviderDetails[];
  readonly resultCount: string;
  readonly isLoadingPharmacyResults?: boolean;
  readonly pharmacyResultsPageNumber: number;
  readonly setPharmacyResultsPageNumber: React.Dispatch<React.SetStateAction<number>>;
  readonly pharmacyResultsPerPage: number;
  readonly setSelectedPharmacy: React.Dispatch<React.SetStateAction<ProviderDetails | null>>;
}

const TRANSLATION_PATH = "DIRECT_MEMBER_REIMBURSEMENT.directMemberReimbursementClaimDetailsForm";

export const DirectMemberReimbursementPharmacySearchResults = ({
  largeFieldsColumns,
  pharmacies,
  isLoadingPharmacyResults,
  pharmacyResultsPageNumber,
  setPharmacyResultsPageNumber,
  pharmacyResultsPerPage,
  setSelectedPharmacy,
  resultCount,
}: PharmacySearchResults) => {
  const { t: translate } = useTranslation();

  return (
    <Grid spacing="medium">
      <Grid.Span columns={largeFieldsColumns}>
        <LoadingGroup loading={isLoadingPharmacyResults}>
          <LoadingGroup.Placeholder fallback={<LoadingSkeleton count={pharmacyResultsPerPage} style={{ height: "100px" }} />}>
            {pharmacies?.length > 0 && (
              <Stack spacing="medium">
                <Heading>{translate(`${TRANSLATION_PATH}.searchResults`)}</Heading>
                {pharmacies?.map((pharmacy, index: number) => (
                  <DirectMemberReimbursementProviderDetailsCard
                    key={`pharmacy-card-${index}`}
                    provider={pharmacy}
                    isSelected={false}
                    setSelectedProvider={setSelectedPharmacy}
                  />
                ))}
                {Number(resultCount) > pharmacyResultsPerPage && (
                  <Pager
                    pageNumber={pharmacyResultsPageNumber}
                    setPageNumber={setPharmacyResultsPageNumber}
                    resultCount={resultCount}
                    resultsPerPage={pharmacyResultsPerPage}
                    disabled={isLoadingPharmacyResults}
                  />
                )}
              </Stack>
            )}
            {Number(resultCount) === 0 && <DirectMemberReimbursementNoResults isSingular={false} />}
          </LoadingGroup.Placeholder>
        </LoadingGroup>
      </Grid.Span>
    </Grid>
  );
};
